import React from "react";

import './SearchResultRow.scss';

const SearchResultRow = ({children, to, onClick}) => {
	return (<div onClick={() => onClick(to)} className="header-search-results-row">{children}</div>)
};

export default SearchResultRow;